import React, { useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  Typography,
  Box,
  Button,
  DialogContent,
  Dialog,
} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

import styles from "../../../../styles/global-styles";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert";
import ProductDistributionForm from "../forms/ProductDistributionForm";
import { CardCatalogueService } from "../../../../services/cardCatalogue.service";

const usetSyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  backgroundIcon: styles.backgroundIcon,
  numberProducts: {
    marginRight: 20,
    fontSize: 22,
    fontWeight: 800,
  },
}));

const ResumeCashCardDistribution = ({
  addAlert,
  detailAlert,
  detailProduct,
  bulkCashCard,
}) => {
  const classes = usetSyles();
  const [checkedId, setCheckedId] = useState([]);
  const [cardInfo, setCardInfo] = useState({});
  const [openModalDistribution, setOpenModalDistribtuion] =
    React.useState(false);

  useEffect(() => {
    (async function () {
      try {
        const {
          data: { name, amount },
        } = await CardCatalogueService.getCardCatalogueById(
          detailProduct.cardCatalogueId
        );
        setCardInfo({ ...cardInfo, name, amount });
      } catch (error) {
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    })();
  }, []);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSelectCashCardId = (e, cashCardId) => {
    if (e.target.checked)
      setCheckedId((checkedId) => [...checkedId, cashCardId]);
    else {
      const newArray = checkedId.filter((item) => item !== cashCardId);
      setCheckedId(newArray);
    }
  };

  const handleCloseModal = (openModal) => setOpenModalDistribtuion(openModal);

  return (
    <React.Fragment>
      <Grid
        style={{ marginTop: 20 }}
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
      >
        {Object.values(cardInfo).length > 0 && (
          <Grid item xs={12}>
            <Typography
              variant="h4"
              style={{ fontWeight: "bold" }}
              component={"div"}
            >
              Tarjeta de saldo
            </Typography>
          </Grid>
        )}
        <br></br>
        <Grid item xs={12} style={{ marginTop: "55px" }}>
          <Typography
            variant="h5"
            gutterBottom
            style={{ fontWeight: "lighter" }}
            component={"div"}
          >
            Resumen de registro
          </Typography>
          <Typography variant="body1" component={"div"}>
            <Box
              mt={2}
              style={{ color: "#1C2668", fontSize: 22, fontWeight: 800 }}
            >
              <span className={classes.numberProducts}>{checkedId.length}</span>
              Productos Seleccionados
            </Box>
          </Typography>
        </Grid>

        <Grid item xs={4} md={2} style={{ marginTop: "35px" }}></Grid>
        <Grid
          item
          xs={4}
          md={3}
          style={{ marginTop: "35px", fontSize: 18, fontWeight: 600 }}
        >
          id
        </Grid>
        <Grid
          item
          xs={4}
          md={3}
          style={{ marginTop: "35px", fontSize: 18, fontWeight: 600 }}
        >
          Compañia y monto
        </Grid>
        <Grid item xs={12} md={4} style={{ marginTop: "35px" }}></Grid>
        {bulkCashCard.map((item, key) => {
          return (
            <React.Fragment key={key}>
              <Grid item xs={4} md={2} style={{ marginTop: "20px" }}>
                <Checkbox
                  onChange={(e) => {
                    handleSelectCashCardId(e, item.cashCardId);
                  }}
                  color="primary"
                  inputProps={{ "aria-label": "secondary checkbox" }}
                />
              </Grid>
              <Grid
                item
                xs={3}
                md={3}
                style={{ marginTop: "20px", fontSize: 18 }}
              >
                {item.cashCardId}
              </Grid>
              <Grid
                item
                xs={4}
                md={3}
                style={{ marginTop: "20px", fontSize: 18 }}
              >
                {cardInfo.name}
                {"   "}${cardInfo.amount}
              </Grid>
              <Grid item xs={12} md={4} style={{ marginTop: "20px" }}></Grid>
            </React.Fragment>
          );
        })}

        {checkedId.length > 0 && (
          <Grid item xs={12} md={4} style={{ marginTop: "35px" }}>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: "20px" }}
              type="submit"
              onClick={() => setOpenModalDistribtuion(true)}
              endIcon={
                <ArrowRightAltIcon
                  className={classes.backgroundIcon}
                  color="primary"
                ></ArrowRightAltIcon>
              }
            >
              Distribución
            </Button>
          </Grid>
        )}
      </Grid>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        fullScreen={fullScreen}
        open={openModalDistribution}
        onClose={() => setOpenModalDistribtuion(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent style={{ overflow: "hidden" }}>
          <ProductDistributionForm
            onClose={handleCloseModal}
            itemsIdSelected={checkedId}
            detailProduct={detailProduct}
            productType="cashCard"
            bulkCashCard={bulkCashCard}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(ResumeCashCardDistribution);
